import React, { useEffect, useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Box,
  Popover,
  Collapse,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import { SearchBar } from "./SearchBar";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import SwitchParticipant from "../../PopUp/SwitchPartcipant";
import { getAllParticipants } from "../../fiscalUpgrade/services/ParticipantsServices/SwitchParticipartService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import * as constants from "../../../constants";
import toast from "react-hot-toast";
import { resetAllFundDetails } from "../../../store/features/auth/newFundSlice";
import { resetTransferFunds } from "../../../store/features/auth/transferFundsSlice";
import { setParticipantAdminProfile } from "../../../store/features/auth/participantAdminProfileSlice";
import ParticipantSummaryReport from "../../PopUp/FiscalReports/ParticipantSummaryReport";
import ClientstatementReport from "../../PopUp/FiscalReports/ClientstatementReport";
import LoanStatementReport from "../../PopUp/FiscalReports/LoanStatementReport";
import { resetTableState } from "../../../store/tableSlice";
import { tablesToReset } from "../../../store/tableConstants";
import { useTranslation } from "react-i18next";
import { setProjectInvoiceApproval } from "../../../store/FiscalSettings/ProjectInvoiceApproverSlice";
import { getInvoiceTasksSummary } from "../../fiscalUpgrade/services/Invoices/Tasks/InvoiceTasksSummaryService";
import { getRcboInvoiceListDetails } from "../../fiscalUpgrade/services/RCBOInvoices/RCBOInvoiceServices";
import { resetInvoiceCounts, setRcboInvoiceCount, setInvoiceTasksCount, setRefreshCountFlag } from "../../../store/Invoice/invoiceCountSlice";
import { getParticipantExternalSystemDetails } from "../../fiscalUpgrade/Utils/participantExternalSystemUtils";
import { notifyUser } from "../../fiscalUpgrade/Utils/notifyUser";
import ParticipantMonthlyReport from "../../PopUp/FiscalReports/MonthlyReport";
import { getClientDetailsByClientName } from "../../fiscalUpgrade/Utils/ClientSettingsTable";

const drawerWidth = 240;
interface SubItem {
  label?: string;
  name: string;
  route: string;
  isDivider?: boolean;
}

interface MenuListItem {
  label: string;
  subItems?: SubItem[]; // Optional sub-items
  icon: string;
}

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    position: "fixed",
    top: 70,
    left: 0,
    height: "100vh", // Full height of the viewport
    zIndex: 1,
    overflowY: "auto", // Enable scrolling for long content
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    padding: theme.spacing(2),
    backgroundColor: "#CAE3E8",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingBottom: theme.spacing(20),

    /* Custom Scrollbar Styling */
    "&::-webkit-scrollbar": {
      width: "6px", // Thin scrollbar
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent", // Track background
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#66A0B3", // Scrollbar color
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#4E7F8A", // Darker color on hover
    },
  },
}));

const CollapsedDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: theme.spacing(9),
    position: "fixed",
    top: 70,
    left: 0,
    height: "100vh", // Adjust height
    zIndex: 1,
    overflowY: "auto",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: "#CAE3E8",
    /* Custom Scrollbar Styling */
    "&::-webkit-scrollbar": {
      width: "6px", // Thin scrollbar
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent", // Track background
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#66A0B3", // Scrollbar color
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#4E7F8A", // Darker color on hover
    },
  },
}));

interface CustomizeHeaderProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const MiniDrawer: React.FC<CustomizeHeaderProps> = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [submenuItems, setSubmenuItems] = useState<MenuListItem["subItems"]>([]);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [selectedSubIndex, setSelectedSubIndex] = useState<number | null>(null);
  const [isQBOEnabled, setIsQBOEnabled] = useState<string | undefined>("N");
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [openFlag, setOpenFlag] = useState<boolean>(false);
  const [switchPartcipantFlag, setSwitchPartcipantFlag] = useState<boolean>(false);
  const userDetails = useSelector((state: RootState) => state.auth);
  const LoggedinRoleName: string = userDetails?.roles?.roleName || "";
  const participantDetail = useSelector((state: RootState) => state.participantDetails);
  const menuItems = useSelector((state: RootState) => state.menuItems);
  const [isAdminView, setIsAdminView] = useState(false); // true = show adminView = "Y"
  const { t } = useTranslation();
  const translate = t as (key: string) => string;
  const [searchQuery, setSearchQuery] = useState("");
  const [clientOpen, setClientOpen] = useState<boolean>(false);
  const [loanOpen, setLoanOpen] = useState<boolean>(false);
  const [pSumOpen, setPSumOpen] = useState<boolean>(false);
  const [pMonOpen, setPMonOpen] = useState<boolean>(false);
  const contactInformation = useSelector((state: RootState) => state.participantAdminProfile);
  const [userRole] = useState<string>(contactInformation.participantAdminProfile);
  const rcboInvoiceCount = useSelector((state: RootState) => state.invoiceCount.rcboInvoiceCount);
  const invoiceTasksCount = useSelector((state: RootState) => state.invoiceCount.invoiceTasksCount);
  const refreshCountFlag = useSelector((state: RootState) => state.invoiceCount.refreshCountFlag);
  const [invoiceCountsLoading, setInvoiceCountsLoading] = useState(false);
  const ClientDetails = getClientDetailsByClientName(userDetails?.clientVo?.name);
  const projectInvoiceRoles = [
    constants.ROLES_PROJECT_MANAGER,
    constants.ROLES_PROJECT_APPROVER,
    constants.ROLES_PROJECT_ANALYST,
  ];
  const handlePopUpClose = () => {
    setClientOpen(false);
  };
  const handlePartClose = () => {
    setPSumOpen(false);
  };
  const handlePMonClose = () => {
    setPMonOpen(false);
  };
  const handleLoanPopUpClose = () => {
    setLoanOpen(false);
  };
  const toggleDrawer = () => {
    setOpen((prev: boolean) => !prev);
  };

  const handleMouseEnter = (
    event: React.MouseEvent<HTMLElement>,
    item: MenuListItem,
    index: number
  ) => {
    if (item.subItems) {
      setAnchorEl(event.currentTarget); // Update anchor
      setSubmenuItems(item.subItems); // Update submenu items
      setOpenFlag(true); // Open new popover
    } else {
      // If no subItems, close popover
      setAnchorEl(null);
      setSubmenuItems([]);
      setOpenFlag(false);
    }
    setSelectedIndex(index);
  };

  // Handle mouse leave to close submenu only when leaving both icon and popover
  const handleMouseLeave = (event: React.MouseEvent<HTMLElement>) => {
    if (!popoverRef.current?.contains(event.relatedTarget as Node)) {
      setAnchorEl(null);
      setSubmenuItems([]);
      setOpenFlag(false);
    }
  };

  // Handle mouse enter in popover to prevent closing
  const handlePopoverEnter = () => {
    setOpenFlag(true);
  };

  // Handle mouse leave in popover to close when moving outside
  const handlePopoverLeave = (event: React.MouseEvent<HTMLElement>) => {
    const target = event.relatedTarget;
    if (!target || !(target instanceof Node) || !anchorEl?.contains(target)) {
      setAnchorEl(null);
      setSubmenuItems([]);
      setOpenFlag(false);
    }
  };
  // Reference for Popover
  const popoverRef = React.useRef<HTMLDivElement>(null);

  const handleToggle = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index); // Toggle sub-menu expansion
  };
  const handleItemClick = (index: number, item: MenuListItem) => {
    if (item.subItems) {
      handleToggle(index); // Toggle the sub-menu for items with subItems
    }
    setSelectedIndex(index); // Always set the selected index
  };

  const isPopoverOpen = Boolean(anchorEl);
  useEffect(() => {
    if (userDetails && userDetails?.defaultParticipantId != 0 &&
      contactInformation?.participantAdminProfile !== constants.ADMIN_VIEW && userDetails.clientId > 0) {
      setIsAdminView(false);
      getParticipants(userDetails?.defaultParticipantId);
    } else {
      setIsAdminView(true);
    }
  }, [userDetails]);

  useEffect(() => {
    if (refreshCountFlag) {
      const fetchInvoiceCounts = async () => {
        setInvoiceCountsLoading(true);
        try {
          await Promise.all([
            getInvoiceSummaryListInfo(),
            invoiceTasksSummaryList(),
          ]);
        } finally {
          setInvoiceCountsLoading(false);
        }
        dispatch(setRefreshCountFlag(false));
      };

      dispatch(resetInvoiceCounts());
      fetchInvoiceCounts();
    }
  }, [
    refreshCountFlag,
  ]);

  useEffect(() => {
    if (userDetails && userDetails?.defaultParticipantId > 0 && userDetails.roles?.roleName === constants.ROLES_PARTICIPANT_USER) {
      fetchQBOStatus();
    }
  }, [userDetails?.defaultParticipantId, userDetails?.clientId]);

  async function fetchQBOStatus() {
    const status = await getParticipantExternalSystemDetails(
      userDetails.defaultParticipantId,
      userDetails.clientId,
      constants.QBO
    );
    setIsQBOEnabled(status);
  }

  async function getInvoiceSummaryListInfo() {
    // Find the "invoices" menu item
    const invoiceArray = menuItems?.menuItems || [];
    const invoicesMenu = invoiceArray.find((item: any) => item.label === constants.LABEL_NAME_INVOICES);
    // Check if subItems includes "rcboInvoices"
    const hasRcboInvoices = invoicesMenu && invoicesMenu.subItems.some((sub: any) => sub.label === constants.SUBMENU_NAME_RCBOINVOICES);

    if (hasRcboInvoices) {
      try {
        const Vo = {
          participantId: contactInformation.participantAdminProfile === constants.ADMIN_VIEW ? 1 : userDetails.defaultParticipantId,
          status: constants.TASK_STATUS_OPEN,
        };
        const responseList = await getRcboInvoiceListDetails(Vo);
        if (responseList.status === constants.STATUS_CODES.SUCCESS) {
          const allData = responseList.data.data;
          if (allData != null) {
            dispatch(setRcboInvoiceCount(responseList.data.data.length));
          } else {
            dispatch(setRcboInvoiceCount(0));
          }
        } else {
          dispatch(setRcboInvoiceCount(0));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      dispatch(setRcboInvoiceCount(0));
    }
  }

  async function invoiceTasksSummaryList() {
    const invoiceArray = menuItems?.menuItems || [];
    const invoicesMenu = invoiceArray.find((item: any) => item.label === constants.LABEL_NAME_INVOICES);
    // Check if subItems includes "rcboInvoices"
    const hasInvoiceTask = invoicesMenu && invoicesMenu.subItems.some((sub: any) => sub.label === constants.SUBMENU_NAME_INVOICESTASKS);
    if (hasInvoiceTask) {
      let filter: any = {
        participantId: contactInformation.participantAdminProfile === constants.ADMIN_VIEW ? 0 : userDetails.defaultParticipantId,
        clientId: userDetails.clientId,
        isActive: constants.IS_ACTIVE_YES,
        status: constants.TASK_STATUS_PENDING,
        approverMail: userDetails.emailId,

      };
      try {
        const response = await getInvoiceTasksSummary(filter);
        if (response.status === constants.STATUS_CODES.SUCCESS) {
          dispatch(setInvoiceTasksCount(response?.data?.data?.length ?? 0));
          if (response?.data?.data?.length > 0 && contactInformation?.participantAdminProfile !== constants.ADMIN_VIEW) {
            notifyUser(translate('youHave') + ' ' + response?.data?.data?.length + ' ' + translate('taskToActOn'), 'info');

          }
        } else {
          dispatch(setInvoiceTasksCount(0));
        }
      } catch (error) {
        dispatch(setInvoiceTasksCount(0));
        console.error(error);
      }
    } else {
      dispatch(setInvoiceTasksCount(0));
    }
  }

  async function getParticipants(id: any) {
    let participantVO = {
      page: -1,
      size: -1,
      isActive: "Y",
      clientId: userDetails.clientId,
    };
    try {
      const promise = await getAllParticipants(participantVO);
      const name = promise.data?.data?.data.find(
        (item: any) => item.participantId === id
      );
      if (userDetails?.roles?.roleName === constants.ROLES_PROJECT_MANAGER) {
        dispatch(
          setParticipantAdminProfile({
            participantAdminProfile: constants.ADMIN_VIEW,
          })
        );
      } else {
        dispatch(
          setParticipantAdminProfile({
            participantAdminProfile: name?.participantName,
          })
        );
      }
    } catch (error) {
      console.error(error);
    }
  }
  const handleSearch = (value: string) => {
    setSearchQuery(value.toLowerCase());
  };
  const filteredMenuItems = React.useMemo(() => {
    if (!menuItems?.menuItems) return [];
    return menuItems.menuItems
      .map(item => {
        const allowedAdminViews = isAdminView
          ? ["Y", "B"]
          : ["N", "B"];

        // Filter subItems based on allowed admin views and hide "setUpqbo" if disabled
        const filteredSubItems = item.subItems?.filter(sub => {
          if (sub.label === "setUpqbo" && isQBOEnabled !== constants.IS_ACTIVE_YES) {
            return false;
          }
          if (
              sub.label === "settings" &&
              contactInformation?.participantAdminProfile !== constants.ADMIN_VIEW && ClientDetails?.name === constants.CLIENT_NAME_DC_GARY
            ) {
              return false;
            }
          return allowedAdminViews.includes(sub.adminView);
        }) || [];

        const includeParent =
          (allowedAdminViews.includes(item.adminView) && filteredSubItems.length > 0) ||
          filteredSubItems.length > 0;

        if (!includeParent) return null;

        const updatedLabel = item.label === "Gear Icon" ? "Settings" : (item.label === "invoices"
          ? `${translate(item.label ?? "")} (${rcboInvoiceCount + invoiceTasksCount})`
          : translate(item.label ?? "")
        );

        return {
          ...item,
          label: updatedLabel,
          subItems: filteredSubItems,
        };
      })
      .filter(Boolean);
  }, [menuItems, isAdminView, LoggedinRoleName, rcboInvoiceCount, invoiceTasksCount, translate, isQBOEnabled, contactInformation]);


  // Filter navigation items based on the search query
  const filteredNavigationItems = filteredMenuItems.filter(
    (item: any) =>
      item.label.toLowerCase().includes(searchQuery) ||
      (item.subItems &&
        item.subItems.some((subItem: any) =>
          subItem.label.toLowerCase().includes(searchQuery)
        ))
  );

  return (
    <>
      {userDetails.isLogin == true && (
        <Box>
          {open ? (
            <StyledDrawer variant="permanent">
              <Box
                sx={{ display: "flex", alignItems: "center", paddingBottom: 2 }}
              >
                <SearchBar onSearch={handleSearch} />
                <IconButton
                  onClick={toggleDrawer}
                  className="circle-icon-button"
                  sx={{ paddingLeft: 2 }}
                >
                  <ArrowBackIosIcon fontSize="small" />
                </IconButton>
              </Box>

              {/* Ensures the list starts immediately after the Box */}
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <List sx={{ width: "100%" }}>
                  {" "}
                  {/* Ensures list takes full width */}
                  {filteredNavigationItems.map((item: any, index) => (
                    <div key={item.label}>
                      {item.label === "Settings" && (
                        <Divider
                          sx={{
                            margin: "10px 0",
                            borderColor: "rgba(0, 0, 0, 0.2)",
                          }}
                        />
                      )}
                      <ListItem
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                        sx={{
                          backgroundColor:
                            selectedIndex === index || expandedIndex === index
                              ? "white"
                              : hoveredIndex === index
                                ? "lightgray"
                                : "none",
                          "&:hover": {
                            backgroundColor:
                              selectedIndex === index ? "white" : "#66A0B3",
                          },
                          margin: "5px 0",
                          marginBottom: "0px",
                          boxShadow:
                            selectedIndex === index || expandedIndex === index
                              ? "0px 2px 4px rgba(0, 0, 0, 0.1)"
                              : "none",
                        }}
                        onClick={() => handleItemClick(index, item)}
                      >
                        <ListItemIcon>
                          <img
                            src={item.icon}
                            alt={item.label}
                            style={{
                              width:
                                item.label === "Settings" ? "50.5px" : "30px",
                              marginRight:
                                item.label === "Settings" ? "0px" : "10px",
                              cursor: "pointer",
                            }}
                          />
                        </ListItemIcon>
                        <ListItemText primary={item.label} />
                        {item.subItems && (
                          <IconButton>
                            {expandedIndex === index ? (
                              <ArrowDropUpIcon />
                            ) : (
                              <ArrowDropDownIcon />
                            )}
                          </IconButton>
                        )}
                      </ListItem>

                      {/* Sub-menu items */}
                      {item.subItems && (
                        <Collapse
                          in={expandedIndex === index}
                          timeout="auto"
                          unmountOnExit
                          sx={{
                            backgroundColor: "white",
                            paddingBottom: "8px",
                          }}
                        >
                          <List component="div" disablePadding>
                            {item.subItems
                              .filter(
                                (subItem: any) =>
                                  !(
                                    subItem.label === constants.NEW_FUND &&
                                    !constants.FUND_ALLOWED_ROLES.includes(
                                      LoggedinRoleName
                                    )
                                  )
                              )
                              .map((subItem: any, subIndex: any) => {
                                if (subItem.isDivider) {
                                  return (
                                    <Divider
                                      key={`divider-${subIndex}`}
                                      sx={{ my: 1 }}
                                    />
                                  );
                                }

                                return (
                                  <ListItem
                                    key={subIndex}
                                    component={
                                      subItem.route === constants.ADMIN_VIEW_PATH ||
                                        subItem.route === constants.SWITCH_PARTICIPANT_PATH
                                        ? "div"
                                        : Link
                                    }
                                    to={
                                      subItem.route === constants.ADMIN_VIEW_PATH ||
                                        subItem.route === constants.SWITCH_PARTICIPANT_PATH
                                        ? undefined
                                        : subItem.route
                                    }
                                    onClick={(event: {
                                      preventDefault: () => void;
                                    }) => {
                                      setSelectedSubIndex(subIndex);
                                      dispatch(resetAllFundDetails());
                                      dispatch(resetTransferFunds());
                                      if (
                                        subItem.route === constants.ADMIN_VIEW_PATH
                                      ) {
                                        event.preventDefault();
                                        setIsAdminView(true);
                                        if (projectInvoiceRoles.includes(userDetails?.roles?.roleName ?? ""))
                                          navigate(constants.VENDOR_INVOICE_PATH);
                                        else
                                          navigate(constants.RCBO_SUMMARY_PATH);
                                        dispatch(
                                          setParticipantAdminProfile({
                                            participantAdminProfile:
                                              constants.ADMIN_VIEW,
                                          })
                                        );
                                        tablesToReset.forEach((tableKey) => {
                                          dispatch(
                                            resetTableState({ tableKey })
                                          );
                                        });
                                      } else if (
                                        subItem.route === constants.SWITCH_PARTICIPANT_PATH
                                      ) {
                                        event.preventDefault();
                                        setSwitchPartcipantFlag(true);
                                        tablesToReset.forEach((tableKey) => {
                                          dispatch(
                                            resetTableState({ tableKey })
                                          );
                                        });

                                      } else if (
                                        subItem.route === constants.ENTER_FUND_DETAILS_PATH &&
                                        LoggedinRoleName ===
                                        constants.ROLES_PARTICIPANT_USER &&
                                        participantDetail.funds.filter(
                                          (item: any) =>
                                            item.isActive ===
                                            constants.IS_ACTIVE_YES
                                        ).length >= 10
                                      ) {
                                        event.preventDefault();
                                        notifyUser(translate('participantUsersCanCreateUpTo10ActiveFundsOnly'), 'error', translate('fund'));
                                      } else if (
                                        subItem.route === constants.CLIENT_STATEMENT_PATH
                                      ) {
                                        event.preventDefault();
                                        setClientOpen(true);
                                      } else if (
                                        subItem.route === constants.LOAN_STATEMENT_PATH
                                      ) {
                                        event.preventDefault();
                                        setLoanOpen(true);
                                      } else if (
                                        subItem.route === constants.PARTICIPANT_SUMMARY_PATH
                                      ) {
                                        event.preventDefault();
                                        setPSumOpen(true);
                                      } else if (
                                        subItem.route === constants.MONTHLY_STATEMENT_PATH
                                      ) {
                                        event.preventDefault();
                                        setPMonOpen(true);
                                      } else if (
                                        subItem.route === constants.SETTING_SUMMARY_SCREENS_PATH
                                      ) {
                                        dispatch(
                                          setProjectInvoiceApproval({
                                            searchProjectManager: "",
                                            searchBusinessManager: "",
                                            searchProjectApprover: "",
                                          })
                                        );
                                      } else {
                                        setSwitchPartcipantFlag(false);
                                      }
                                    }}
                                    sx={{
                                      paddingLeft: 8,
                                      backgroundColor: "white",
                                      "&:hover": {
                                        backgroundColor: "#f1f1f1",
                                      },
                                      cursor: "pointer",
                                    }}
                                  >
                                    <ListItemText
                                      primary={subItem?.label === "rcboInvoices"
                                        ? `${translate(subItem?.label ?? "")}${rcboInvoiceCount > 0 ? ` (${rcboInvoiceCount})` : ""}`
                                        : subItem?.label === "invoiceTasks"
                                          ? `${translate(subItem?.label ?? "")} ${invoiceTasksCount > 0 ? ` (${invoiceTasksCount})` : ""}`
                                          : translate(subItem?.label ?? "")
                                      }
                                      primaryTypographyProps={{
                                        style: {
                                          color: "black"
                                        },
                                      }}
                                    />
                                  </ListItem>
                                );
                              })}
                          </List>
                        </Collapse>
                      )}
                    </div>
                  ))}
                </List>
              </Box>
            </StyledDrawer>
          ) : (
            <CollapsedDrawer variant="permanent">
              <Box paddingLeft={1}>
                <IconButton
                  onClick={toggleDrawer}
                  className="circle-icon-button"
                  sx={{ mt: 1, paddingLeft: 1 }}
                >
                  <ArrowForwardIosIcon fontSize="small" />
                </IconButton>
              </Box>
              <List>
                {filteredMenuItems.map((item: any, index) => (
                  <div key={item.label}>
                    {item.label === "Settings" && (
                      <Divider
                        sx={{
                          margin: "10px 0",
                          borderColor: "rgba(0, 0, 0, 0.2)",
                        }}
                      />
                    )}
                    <ListItem
                      sx={{
                        backgroundColor:
                          selectedIndex === index
                            ? "white"
                            : hoveredIndex === index
                              ? "lightgray"
                              : "none",
                        "&:hover": {
                          backgroundColor:
                            selectedIndex === index ? "white" : "none",
                        },
                        margin: "5px 0",
                        boxShadow:
                          selectedIndex === index
                            ? "0px 2px 4px rgba(0, 0, 0, 0.1)"
                            : "none",
                      }}
                      onClick={() => handleItemClick(index, item)} // Call the handleItemClick function here
                    >
                      <ListItemIcon
                        onMouseEnter={(event) =>
                          handleMouseEnter(event, item, index)
                        }
                        onMouseLeave={handleMouseLeave}
                      >
                        <img
                          src={item.icon}
                          alt={item.label}
                          style={{
                            width:
                              item.label === "Settings" ? "50.5px" : "30px",
                            marginLeft:
                              item.label === "Settings" ? "-10px" : "0px",
                            cursor: "pointer",
                          }}
                        />
                      </ListItemIcon>
                    </ListItem>
                  </div>
                ))}
              </List>
              <Popover
                ref={popoverRef}
                open={isPopoverOpen}
                anchorEl={anchorEl}
                onClose={handleMouseLeave} // Keep this to close on clicking outside
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                PaperProps={{
                  style: {
                    backgroundColor: "white", // Keep background white
                    padding: "8px 0",
                  },
                }}
                onMouseEnter={handlePopoverEnter} // Prevent closing when entering popover
                onMouseLeave={handlePopoverLeave} // Close when leaving both icon and popover
              >
                <List>
                  {submenuItems?.map((subItem, subIndex) => {
                    if (subItem.isDivider) {
                      return (
                        <Divider key={`divider-${subIndex}`} sx={{ my: 1 }} />
                      );
                    }

                    return (
                      <ListItem
                        key={subIndex}
                        component={
                          subItem.route === constants.ADMIN_VIEW_PATH ||
                            subItem.route === constants.SWITCH_PARTICIPANT_PATH ||
                            subItem.route === constants.CLIENT_STATEMENT_PATH
                            ? "div"
                            : Link
                        }
                        to={
                          subItem.route === constants.ADMIN_VIEW_PATH ||
                            subItem.route === constants.SWITCH_PARTICIPANT_PATH ||
                            subItem.route === constants.LOAN_STATEMENT_PATH
                            ? undefined
                            : subItem.route
                        }
                        onClick={(event: { preventDefault: () => void }) => {
                          setSelectedSubIndex(subIndex);
                          switch (subItem.route) {
                            case constants.ADMIN_VIEW_PATH:
                              event.preventDefault();
                              setIsAdminView(true);
                              if (projectInvoiceRoles.includes(userDetails?.roles?.roleName ?? ""))
                                navigate(constants.VENDOR_INVOICE_PATH);
                              else
                                navigate(constants.RCBO_SUMMARY_PATH);
                              dispatch(
                                setParticipantAdminProfile({
                                  participantAdminProfile: constants.ADMIN_VIEW,
                                })
                              );
                              break;

                            case constants.SWITCH_PARTICIPANT_PATH:
                              event.preventDefault();
                              setSwitchPartcipantFlag(true);
                              break;

                            case constants.CLIENT_STATEMENT_PATH:
                              setClientOpen(true);
                              break;

                            case constants.LOAN_STATEMENT_PATH:
                              setLoanOpen(true);
                              break;

                            case constants.SETTING_SUMMARY_SCREENS_PATH:
                              dispatch(
                                setProjectInvoiceApproval({
                                  searchProjectManager: "",
                                  searchBusinessManager: "",
                                  searchProjectApprover: "",
                                })
                              );
                              break;

                            default:
                              setSwitchPartcipantFlag(false);
                          }
                        }}
                        sx={{
                          padding: "8px 16px",
                          color: "inherit",
                          "&:focus": { color: "inherit" },
                          "&:active": { color: "inherit" },
                          "&:hover": {
                            backgroundColor: "#f1f1f1",
                            color: "inherit",
                          },
                        }}
                      >
                        <ListItemText primary={translate(subItem?.label ?? '')} />
                      </ListItem>
                    );
                  })}
                </List>
              </Popover>
            </CollapsedDrawer>
          )}
          <ParticipantSummaryReport
            open={pSumOpen}
            handleClose={handlePartClose}
          />
          <ParticipantMonthlyReport
            open={pMonOpen}
            handleClose={handlePMonClose}
          />
          <ClientstatementReport
            open={clientOpen}
            handleClose={handlePopUpClose}
          />
          <LoanStatementReport
            open={loanOpen}
            handleClose={handleLoanPopUpClose}
          />
          <SwitchParticipant
            setSwitchPartcipantFlag={setSwitchPartcipantFlag}
            open={switchPartcipantFlag}
            titlePopUp={translate("selectParticipantToSwitch")}
          />
        </Box>
      )}
    </>
  );
};

export default MiniDrawer;
